import React from 'react';

const Pin = React.forwardRef<React.ElementRef<'svg'>, React.ComponentPropsWithoutRef<'svg'>>(
  (props, ref) => (
    <svg ref={ref} viewBox="0 0 18 18" fill="none" {...props}>
      <circle cx="10.2529" cy="7.40896" r="5" transform="rotate(45 10.2529 7.40896)" fill="black" />
      <path
        d="M5.30322 12.3586L3.53546 14.1264"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
);

export default Pin;
